import { render } from "./background.vue?vue&type=template&id=93eb8280"
const script = {}

import "./background.vue?vue&type=style&index=0&id=93eb8280&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__